
function Directive (){
    return {
        restrict: 'E',
        template: require('./detailFooter.jade')
    }
}

export default Directive;


// WEBPACK FOOTER //
// ./app/common/widgets/detailFooter.js